import React from 'react';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

const customMuiTheme = getMuiTheme({fontFamily: 'inherit'});

import FontPickerModalHeader from './font-picker-modal-header';

import RemoveFontOverlay from './remove-font-overlay.jsx';
import MaxFontsOverlay from './max-fonts-overlay.jsx';
import FontList from './font-list/font-list';
import SearchBar from './font-search/search-bar';
import ModalButton from './font-picker-modal-button';
import styles from './font-picker-modal.scss';

const TYPE_DELAY = 200;

export default class FontPickerModal extends React.Component {
  constructor() {
    super();

    this.onClose = this.onClose.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.filterFonts = _.debounce(this.filterFonts.bind(this), TYPE_DELAY);
  }

  updateState() {
    this.props.modalActionsSubject.onNext({type: 'closeModal'});
  }

  onClose() {
    this.updateState({isOpen: false});
  }

  filterFonts(inputValue) {
    this.props.modalActionsSubject.onNext({
      type: 'filterFontList',
      data: inputValue
    });

    if (this.scrollWrapper) {
      this.scrollWrapper.scrollTop = 0;
    }
  }

  getFontPickerModalHeader() {
    return <FontPickerModalHeader onClose={this.onClose} title="Manage Fonts" />;
  }

  onKeyUp(ev) {
    this.filterFonts(ev.target.value);
  }

  getRemoveFontConfirmation() {
    return (
      <RemoveFontOverlay
        fontFamily={this.props.fontFamilyToRemove}
        modalActionsSubject={this.props.modalActionsSubject}
      />
    );
  }

  getMaxFontsOverlay() {
    if (this.props.showMaxFontsOverlay) {
      return <MaxFontsOverlay modalActionsSubject={this.props.modalActionsSubject} />;
    }
  }

  getDialogContent() {
    const fontListRef = fontList => {
      if (fontList && fontList.scrollWrapper) {
        this.scrollWrapper = fontList.scrollWrapper;
      }
    };

    return (
      <div>
        {this.getMaxFontsOverlay()}
        {this.props.showRemoveFontConfirmation ? this.getRemoveFontConfirmation() : null}
        <SearchBar keyUpHandler={this.onKeyUp} />
        <FontList
          modalActionsSubject={this.props.modalActionsSubject}
          fontList={this.props.fontList}
          isLazyLoading={this.props.isLazyLoading}
          ref={fontListRef}
        />
      </div>
    );
  }

  render() {
    const actions = [<ModalButton onClick={this.onClose} label="Done" key={0} />];
    // we need to set overlay className
    // Because otherwise this gets the ol Event.stop
    // hammer by editor.js
    return (
      <MuiThemeProvider muiTheme={customMuiTheme}>
        <Dialog
          title={this.getFontPickerModalHeader()}
          modal={false}
          actions={actions}
          actionsContainerClassName={styles.footer}
          actionsContainerStyle={{padding: '12px 20px'}}
          bodyClassName={styles.dialog}
          autoDetectWindowHeight={false}
          autoScrollBodyContent={false}
          open={this.props.isOpen}
          bodyStyle={{padding: 0}}
          onRequestClose={this.onClose}
          overlayClassName='font-picker-modal-overlay'
        >
          {this.props.isOpen ? this.getDialogContent() : null}
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

FontPickerModal.propTypes = {
  isOpen: React.PropTypes.bool.isRequired,
  fontFamilyToRemove: React.PropTypes.string,
  showRemoveFontConfirmation: React.PropTypes.bool,
  isLazyLoading: React.PropTypes.bool,
  modalActionsSubject: React.PropTypes.object,
  fontList: React.PropTypes.object,
  showMaxFontsOverlay: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-picker-modal.jsx